import { z } from "zod";

export const getOrganizationInvitationSchema = z.object({
	invitationId: z.string().uuid(),
});

export const getOrganizationInvitationsQuerySchema = z.object({
	state: z.enum(["pending", "accepted", "rejected"]),
});
